import { message } from 'antd'
import axiosClient from '../../../../utils/custom-fetch'
import { MetadataType } from '../../../../utils/metadata.types'
import { URL_ENDPOINT_CREATE_DEPT_PROJECT_PERMISSION } from './constants/config.create-dept-project-permission'
import {
  ListCreateDeptProjectPermissionInput,
  CreateDeptProjectPermissionEntity,
  DetailCreateDeptProjectPermissionInput,
  CreateCreateDeptProjectPermissionInput,
  BodyUpdateCreateDeptProjectPermissionIdWithInputInput,
} from '../../../../server-api-hrm.type'

const appEndpoint = URL_ENDPOINT_CREATE_DEPT_PROJECT_PERMISSION

export const getListCreateDeptProjectPermission = async (
  token?: string,
  body?: ListCreateDeptProjectPermissionInput
) => {
  if (!token) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<{
      metadata: MetadataType
      data: CreateDeptProjectPermissionEntity[]
    }>(`${appEndpoint}/list/all`, body)
  } catch {
    message.error('Tải dữ liệu thất bại')
  }

  return null
}

export const getDetailCreateDeptProjectPermission = async (
  token?: string,
  body?: DetailCreateDeptProjectPermissionInput
) => {
  if (!body || !token) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<CreateDeptProjectPermissionEntity>(
      `${appEndpoint}/detail`,
      body
    )
  } catch {
    message.error('Tải dữ liệu thất bại')
  }

  return null
}

export const addCreateDeptProjectPermission = async (
  token?: string,
  body?: CreateCreateDeptProjectPermissionInput
) => {
  if (!body || !token) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<CreateDeptProjectPermissionEntity>(
      `${appEndpoint}/add`,
      body
    )
  } catch {
    message.error('Hành động thất bại')
  }

  return null
}

export const updateCreateDeptProjectPermission = async (
  token?: string,
  body?: BodyUpdateCreateDeptProjectPermissionIdWithInputInput
) => {
  if (!body?.id || !token) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<CreateDeptProjectPermissionEntity>(
      `${appEndpoint}/update`,
      body
    )
  } catch {
    message.error('Hành động thất bại')
  }

  return null
}

export const deleteCreateDeptProjectPermission = async (
  token?: string,
  body?: DetailCreateDeptProjectPermissionInput
) => {
  if (!body || !token) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<CreateDeptProjectPermissionEntity>(
      `${appEndpoint}/delete`,
      body
    )
  } catch {
    message.error('Hành động thất bại')
  }

  return null
}
